import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Row, Col } from "reactstrap";
import MilitaryContent from "./MilitaryContent";
import ProgressBar from "../../../components/ProgressBar";
import _get from "lodash/get";

export class MilitaryContainer extends React.Component {
    render() {
        return (
            <div>
                <Row>
                    <Col xs="12">
                        <ProgressBar percentage={70} />
                    </Col>
                    <Col xs="12">
                        <MilitaryContent />
                    </Col>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        business: _get(state, "appData.business", {})
    };
};
export default withRouter(
    connect(
        mapStateToProps,
        {}
    )(MilitaryContainer)
);
